import { CustomPage as CustomPageState } from "../../../../publicSite/publicSite.module"
import { initOverviewWidget, OverviewState } from "../widgets/overviewWidget.state"
import { searchPageHeader, searchPageWidget } from "./searchPage.widget"

export type SearchPageState = {
    overviewState: OverviewState
} & CustomPageState

export const initialSearchPageState = (): SearchPageState => ({
    widget: searchPageWidget,
    header: searchPageHeader,
    overviewState: initOverviewWidget(true, "search")
})

export type ContentType = keyof typeof contentTypes
export const contentTypes = {
  campaign: "Campagne",
  donatie_pagina: "Donatie",
  news: "Nieuws",
  page: "Pagina",
  topic: "Onderwep",
  verhalen: "Verhaal",
}